import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="bg-black text-white relative overflow-hidden">
      {/* Top curved shape */}
      <div className="absolute top-0 left-0 w-full">
        <div className="h-24 bg-neutral-900 rounded-b-[100%]"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-36 pb-10">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
          {/* Logo + Nav */}
          <div className="flex flex-col items-start gap-6">
            <Link to="/">
              <img
                className=" h-12 lg:h-14"
                alt="Trackit"
                src="/trackitt-logo.png"
              />
            </Link>
            {/* Navigation Links */}
            <div className="flex flex-col md:flex-row gap-4 md:gap-10 text-gray-300 text-lg">
              <Link to="/" className="hover:text-white transition">
                Home
              </Link>
              <Link to={"/events"} className="hover:text-white transition">
                Events
              </Link>
              <Link to={"/Contact"} className="hover:text-white transition">
                Contact Us
              </Link>
              <Link to={"/sign-in"} className="hover:text-white transition">
                Sign In
              </Link>
            </div>
          </div>

          {/* Social Icons */}
          <div className="flex gap-4">
            <a
              href={
                "https://www.facebook.com/people/Track-Itt-Verified/61558262340147/"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-black hover:scale-105 transition"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>

            <a
              href={"https://www.instagram.com/trackit_verified/"}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-black hover:scale-105 transition"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a
              href={"https://x.com/trackitsports"}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-black hover:scale-105 transition"
            >
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-gray-400 text-sm">
          <p className="text-center md:text-left">
            Copyright © Trackit Verified 2026. All Rights Reserved
          </p>

          <div className="flex gap-6">
            <Link to="/terms" className="hover:text-white transition hidden">
              Terms of Service
            </Link>
            <Link to="/privacy" className="hover:text-white transition hidden">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
